<template>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="col-1">
            Name
          </th>
          <th>Usage count</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="interest in interests" :key="interest.id">
          <td class="col-1">
            {{ interest.name }}
          </td>
          <td>{{ interest.usageCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'InterestList',
  async created() {
    await this.$store.dispatch('fetchInterests')
  },
  computed: {
    interests() {
      return this.$store.getters.interests
    }
  }
}
</script>
<style scoped lang="scss">
.table-container {
  width: 100%;
  margin: 30px;
  background-color: white;

  table {
    border-collapse: collapse;

    th,td {
      border: 2px solid #cccccc;
      padding: 10px;
      vertical-align: baseline;
    }

    .col-1 {
      text-align: left;
    }
  }
}
</style>
